const ns = 'app/account-setup/';

export const TOKEN_START = ns + 'TOKEN_START';
export const TOKEN_FINISH = ns + 'TOKEN_FINISH';

export const REMOVE_LOGO = ns + 'REMOVE_LOGO';

export function processPayment() {
  return {
    type: TOKEN_START
  };
}

export function paymentFailed() {
  return {
    type: TOKEN_FINISH
  };
}

export function removeLogo() {
  return {
    type: REMOVE_LOGO
  };
}



// WEBPACK FOOTER //
// ./src/components/app/account-setup/actions.js